module.exports = __webpack_public_path__ + "static/skeleton-e0e6dad467fc2805958901ecdd50399c.jpeg";